export default "__VITE_ASSET__CfmLJOAt__"